export default "__VITE_ASSET__D2wwB8lL__"